const handleFulfilled = (state, action) => {
    state.status = 'succeeded';
    state.workerNationalities = action.payload;
};

const handleFulfilledEmployerNationality = (state, action) => {
    state.status = 'succeeded';
    state.employerNationalities = action.payload;
};

export {
    handleFulfilled,
    handleFulfilledEmployerNationality
};
